'use client';

import { useRef } from 'react';
import Image from "next/image";
import { useTranslations } from 'next-intl';
import { montserratMedium } from "../fonts";
import HomeSectionTitle from './home-section-title';
import AppButton from './app-button';
import GloryBorder from './glory-border';

export default function TradingPlatformMobile() {
  const t = useTranslations('home.tradingPlatform');
  const sectionRef = useRef<HTMLElement>(null);
  
  const handleLaunchApp = () => {
    window.open('https://app.xox.exchange/', '_self');
  };

  return (
    <section
      ref={sectionRef}
      id="trading-platform"
      className="relative lg:min-h-screen flex flex-col items-center justify-center px-6 py-16"
    >
      <div className="w-full max-w-7xl mx-auto">
        {/* Title */}
        <div className="mb-0">
          <HomeSectionTitle
            subtitle={t('subtitle')}
            title={t('title')}
            centered
          />
        </div>

        {/* Trading Platform Image with Button Overlay */}
        <div className="relative mb-8 w-full">
          <GloryBorder>
                    <Image
                      src="/assets/trading-platform.webp"
                      alt={t('altText')}
                      width={3504}
                      height={1916}
                      className="w-full h-auto rounded-[22px]"
                      sizes="100vw"
                      quality={75}
                    />
          </GloryBorder>
          {/* Start Trading Button - Centered on Image */}
          <div className="absolute inset-0 flex items-center justify-center">
            <AppButton
              text={t('startTrading')}
              iconHover="/icons/mobile.svg"
              variant="outline"
              size="sm"
              onClick={handleLaunchApp}
            />
          </div>
        </div>

        {/* Feature Cards Grid - 2x2 on mobile */}
        <div className="flex flex-row flex-wrap gap-x-[4%] gap-y-4 w-full">
          <div className="w-[46%]">
            <div className="w-full flex h-[48px] lg:min-h-[80px] flex-row items-center gap-2 border-1 border-[#111111] bg-[#111111] rounded-2xl px-[4px] sm:px-[12px] py-[4px] sm:py-[8px]">
              <Image
                src="/icons/take-icon-1.svg"
                alt={t('features.ultraLowCosts')}
                width={24}
                height={24}
                className="opacity-100 flex-shrink-0"
              />
              <p className={`${montserratMedium.className} text-[10px] sm:text-xs text-left text-[color:var(--text-primary)]`}>{t('features.ultraLowCosts')}</p>
            </div>
          </div>
          <div className="w-[50%]">
            <div className="w-full flex h-[48px] lg:min-h-[80px] flex-row items-center gap-2 border-1 border-[#111111] bg-[#111111] rounded-2xl px-[4px] sm:px-[12px] py-[4px] sm:py-[8px]">
              <Image
                src="/icons/take-icon-2.svg"
                alt={t('features.nearZeroSlippage')}
                width={24}
                height={24}
                className="opacity-100 flex-shrink-0"
              />
              <p className={`${montserratMedium.className} text-[10px] sm:text-xs text-left text-[color:var(--text-primary)]`}>{t('features.nearZeroSlippage')}</p>
            </div>
          </div>
          <div className="w-[52%]">
            <div className="w-full flex h-[48px] lg:min-h-[80px] flex-row items-center gap-2 border-1 border-[#111111] bg-[#111111] rounded-2xl px-[4px] sm:px-[12px] py-[4px] sm:py-[8px]">
              <Image
                src="/icons/take-icon-3.svg"
                alt={t('features.broadAssetCoverage')}
                width={24}
                height={24}
                className="opacity-100 flex-shrink-0"
              />
              <p className={`${montserratMedium.className} text-[10px] sm:text-xs text-left text-[color:var(--text-primary)]`}>{t('features.broadAssetCoverage')}</p>
            </div>
          </div>
          <div className="w-[44%]">
            <div className="w-full flex h-[48px] lg:min-h-[80px] flex-row items-center gap-2 border-1 border-[#111111] bg-[#111111] rounded-2xl px-[4px] sm:px-[12px] py-[4px] sm:py-[8px]">
              <Image
                src="/icons/take-icon-4.svg"
                alt={t('features.instantExecution')}
                width={24}
                height={24}
                className="opacity-100 flex-shrink-0"
              />
              <p className={`${montserratMedium.className} text-[10px] sm:text-xs text-left text-[color:var(--text-primary)]`}>{t('features.instantExecution')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

